<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHospital_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.751 8.035A2 2 0 0 0 3 9.597v10.347c0 .545.21 1.068.586 1.454C3.96 21.783 4.47 22 5 22h14c.53 0 1.04-.217 1.414-.602.375-.386.586-.909.586-1.454V9.597a2 2 0 0 0-.751-1.562l-7-5.597a2 2 0 0 0-2.498 0zm6.963 1.745h2.572v2.571h2.571v2.572h-2.571v2.571h-2.572v-2.571H8.143V12.35h2.571z"
        clip-rule="evenodd"
    />
</svg>
